// extracted by mini-css-extract-plugin
export var measureBox = "_3r-0";